import { cn } from '@/ui/utils'
import { cssInterop } from 'nativewind'
import * as React from 'react'
import Svg, { Path } from 'react-native-svg'

export enum LogoColorVariant {
	LIGHT = '#95CFC4',
	DARK = '#106A5C',
	BRIGHT = '#B5F6AE',
}

type LogoProps = {
	className?: string
	color?: LogoColorVariant
}

cssInterop(Svg, {
	className: {
		target: 'style',
		nativeStyleToProp: { width: true, height: true },
	},
})

const Logo = ({ className, color = LogoColorVariant.DARK }: LogoProps) => (
	<Svg
		className={cn('lg:h-[50px] lg:w-[120px] h-10 w-20', className)}
		viewBox="0 0 236 104"
		fill="none"
	>
		<Path
			d="M225.506 19.5151V53.712C225.506 56.2589 224.853 58.6276 223.563 60.7536C222.273 62.941 220.511 64.6983 218.329 65.9733C216.15 67.2482 213.738 67.8934 211.161 67.8934C208.584 67.8934 206.188 67.2482 204.037 65.9733C201.823 64.6952 200.045 62.9563 198.756 60.7996C197.466 58.6491 196.813 56.265 196.813 53.7151V19.5151H187.133V53.712C187.133 57.9763 188.227 61.9732 190.382 65.5862C192.539 69.2698 195.489 72.1976 199.144 74.2959C202.803 76.3942 206.847 77.4603 211.158 77.4603C216.458 77.4603 221.279 75.8689 225.506 72.7229V79.8812C225.506 82.3666 224.885 84.7077 223.66 86.8275C222.37 89.0118 220.611 90.7507 218.428 91.998C216.246 93.2423 213.865 93.8721 211.351 93.8721C208.774 93.8721 206.377 93.2269 204.223 91.9489C202.075 90.7354 200.35 89.0303 199.091 86.8767C197.832 84.723 197.195 82.3697 197.195 79.8812V79.3282H187.516V79.8812C187.516 84.0809 188.61 88.0164 190.764 91.5618C192.856 95.1809 195.771 98.078 199.433 100.179C203.095 102.278 207.105 103.344 211.354 103.344C215.472 103.344 219.417 102.296 223.088 100.222C226.678 98.0933 229.591 95.2147 231.745 91.6662C233.902 88.1117 235.027 84.2775 235.096 80.2591V19.5151H225.506Z"
			fill={color}
		/>
		<Path
			d="M73.5472 18.9985L59.8051 59.0603L46.4329 27.4625L46.1656 26.6699H37.8755L24.3355 59.0603L10.7643 19.782L10.4939 18.9985H0L19.3434 75.4629L19.6138 76.2525H28.1121L41.8667 41.7053L55.5528 75.466L55.8264 76.2525H64.3185L83.4008 20.5531L83.9323 18.9985H73.5472Z"
			fill={color}
		/>
		<Path
			d="M190.145 74.6304L185.582 68.4092L185.122 68.4675C184.765 68.5136 183.211 68.5443 182.66 68.5443C178.29 68.5443 176.167 66.1449 176.167 61.2109V0H166.279V62.532C166.279 67.3492 167.6 71.0482 170.202 73.5244C172.521 75.7303 175.869 76.8946 179.888 76.8946C183.568 76.8946 187.416 75.9576 189.312 75.0329L190.145 74.6304Z"
			fill={color}
		/>
		<Path
			d="M160.128 68.4648C159.77 68.5109 158.213 68.5416 157.666 68.5416C153.295 68.5416 151.172 66.1422 151.172 61.2082V0.00341797H141.285V62.5354C141.285 67.3527 142.606 71.0516 145.207 73.5278C147.526 75.7337 150.874 76.898 154.893 76.898C158.359 76.898 161.548 76.3112 163.643 75.2913L164.386 74.9287L160.65 68.4003L160.128 68.4648Z"
			fill={color}
		/>
		<Path
			d="M103.35 68.3907C94.8892 68.3907 89.633 64.3568 89.633 57.8591C89.633 51.5057 95.3524 47.5579 104.559 47.5579C110.356 47.5579 115.892 49.2784 121.024 52.6762V59.6533C116.85 64.9651 109.934 68.3907 103.35 68.3907ZM135.702 67.8745C135.391 67.9145 135.087 67.9329 134.77 67.9329C132.137 67.9329 130.499 65.6042 130.499 61.856V39.1308C130.499 25.8465 121.335 17.9141 105.986 17.9141C99.7818 17.9141 94.2613 19.0754 89.5739 21.3672L89.2693 21.5147L85.7724 31.9326L87.6032 30.7099C92.3808 27.5148 98.01 26.888 104.339 26.888C109.959 26.888 114.202 27.9879 116.949 30.1599C119.651 32.2921 121.021 35.5793 121.021 39.9327V44.0556C115.361 40.8789 109.2 39.2721 102.691 39.2721C96.173 39.2721 90.9105 40.9342 86.593 44.3597C82.3221 47.8406 80.1555 52.5349 80.1555 58.3168C80.1555 64.1664 82.207 68.8976 86.2666 72.3907C90.3479 75.6903 95.3555 77.3615 101.156 77.3615C109.713 77.3615 116.76 74.4091 122.125 68.5842C123.437 73.5981 127.191 76.446 132.575 76.446C135.099 76.446 137.029 75.9729 138.313 75.0389L138.633 74.8055V74.062L136.327 67.7916L135.702 67.8745Z"
			fill={color}
		/>
	</Svg>
)

export default Logo
